import { Injectable } from "@angular/core";
import { AbstractService } from "../../core/AbstractService";
import { TypeActiviteRequest } from "../../data/http/requests/typeactivite.request";
import { TypeActiviteResponse } from "../../data/http/responses/typeactivite.response";
import { HttpClient } from "@angular/common/http";
import { env } from "../../../env/env";
import { AppService } from "../../core/app.service";

@Injectable({ // Ajoutez le décorateur Injectable
    providedIn: 'root' // Rend le service disponible dans toute l'application
})
export class TypeActiviteService extends AbstractService<TypeActiviteRequest, TypeActiviteResponse>{
    constructor(http: HttpClient, appService: AppService) {
        super(`${env.apiUrl}typeactivite`, http, null, appService); 
    }
}